import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomFiltersService } from '../../services/custom-filters.service';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { RegistroComunicazioniDto, RegistroPagamentiDto,  RicercaRegistroPagamentiDto } from '../../model/print-data';
import { formatDate } from '@angular/common';
import { PagedDataset } from '../../model/filters-data';
import { SollecitiService } from '../../services/solleciti.service';

@Component({
  selector: 'app-registro-pagamenti',
  templateUrl: './registro-pagamenti.component.html',
  styleUrl: './registro-pagamenti.component.scss'
})
export class RegistroPagamentiComponent implements OnInit {
  @ViewChild('dt') dt!: Table;

  // resetFlag: boolean = false;


  //services
  private route = inject(ActivatedRoute);
  private solleciti_service = inject(SollecitiService);
  private message_service = inject(MessageService);
  private custom_filters_service = inject(CustomFiltersService);
  // public role_service = inject(RoleService);



  //filtro generale per tutti i tipi di tabella
  filtri = new FormGroup({
    pattern: new FormControl<string|null>(null),
    dataDa: new FormControl<Date|null>(null),
    dataAl: new FormControl<Date|null>(null),
    // tipoComunicazione: new FormControl<string | null>(null),
    // formatoComunicazione: new FormControl<string | null>(null)
  })

  // formatoComunicazione: string[] = [ "EMAIL", "PEC" ];

  // tipoComunicazione: string[] = [ "NOTIFICA_ISCRIZIONE","NOTIFICA_TRASFERIMENTO",  "RESOCONTO_CONTABILE", "SOLLECITO_QUOTA", "SOLLECITO_MULTI" ];

  orderColumnName: string = '';
  order: string = '';
  page: number = 0;
  pageSize: number = 25;
  currentPage: number = 0;

  totaleDati: number = 0;
  lista: RegistroComunicazioniDto[]=[];


  ngOnInit(): void {

    this.inizializzaFiltri();

    this.filtri.valueChanges.subscribe(() => { //gestione sul cambio filtri
      this.resetPagination();
      this.loadData();
    })

  }


  //inizializza i filtri sul routing
  inizializzaFiltri() {
    const data :string | null = sessionStorage.getItem('registro-pagamenti');
    const sessionData: any  = data??JSON.parse(data!);

    if (sessionData) {
      this.filtri.patchValue({
        pattern: sessionData.pattern,
        // formatoComunicazione: sessionData.formatoComunicazione
      })

      this.orderColumnName = sessionData.orderColumn;
      this.order = sessionData.order;

      this.currentPage = Number(sessionData.currentPage);
      this.page = Number(sessionData.page);
      this.pageSize = Number(sessionData.pageSize);
    }
  }

  //gestisce il caricamento della tabella quando siamo sul componente
  private loadData() {

    const values = this.filtri.value;

    const data : RicercaRegistroPagamentiDto = {
      order: this.order,
      orderColumn: this.orderColumnName,
      page: this.page,
      pageSize: this.pageSize,
      pattern: values.pattern?? undefined,
      // formato: values.formatoComunicazione?? undefined,
      // tipo: values.tipoComunicazione?? undefined,
      dataDal: values.dataDa?formatDate(values.dataDa, 'yyyy-MM-dd', 'en'):undefined,
      dataAl: values.dataAl?formatDate(values.dataAl, 'yyyy-MM-dd', 'en'):undefined
    }

    // const data: SearchFilters = this.custom_filters_service.sessionStorageUpdate(values, this.componente, tabData);

    this.solleciti_service.ricercaRegistroPagamenti(data).subscribe({
      next: (result: PagedDataset<RegistroPagamentiDto>) => {
        this.lista = result.lista;
        this.totaleDati = result.conteggio;
      },
      error: (error) => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
      }
    })
  }

  //resertta paginazione
  resetPagination() {
    this.orderColumnName = '';
    this.order = '';
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;
  }

  // //crea il RouterLink per le voci della tabella
  // generaRoutingLink(delibera: any): string{
  //   return this.dettaglioDeliberaRoute + ((delibera.dataChiusura) ? `iscrizione_chiusa/${delibera.id}` : `${delibera.tipo.codice}/${delibera.id}`);
  // }

  //cambio pagina della tabella
  pageChange(event: any){
    this.currentPage = event.first;
    this.page = event.page;
    this.pageSize = event.rows;

    this.loadData();
  }

  //gestisce ordinamento tabella
  ordinamento(event: any){

    this.orderColumnName = event.sortField ? event.sortField : 'id';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;

    // if(this.resetFlag){
    //   this.resetFlag = false;
    //   this.dt.reset();
    //   return;
    // }

    //if(event.sortOrder === -1) this.resetFlag = true;

    this.loadData();
  }


  resetBoxRicerca(){

  }

  //resetta i filtri di ricerca
  clearFilters(){

    this.resetPagination();

    this.filtri.reset();

    this.dt.reset();

    this.loadData();

  }


  getDataPagamento(item: RegistroPagamentiDto): string | undefined {
    if (!item.dataPagamento)
    return undefined;
    let d = new Date(item.dataPagamento);
    //console.debug(d);
    return formatDate(d, 'dd/MM/yy', 'it_IT');
  }

  getDataRegistrazione(item: RegistroPagamentiDto): string | undefined {
    if (!item.dataRegistrazione)
    return undefined;
    let d = new Date(item.dataRegistrazione);
    //console.debug(d);
    return formatDate(d, 'medium', 'it_IT');
  }


  orderCustom(order: string): number{

    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;

    return check;
  }

  getRoute(item: RegistroPagamentiDto) : string | undefined {
    if (item.iscrittoId)
      return '/contabilita_iscritti/dettaglio_iscritto/'+item.iscrittoId;
    else
    if (item.stpId)
      return '/contabilita_stp/dettaglio_contabile/'+item.stpId;
    else 
      return undefined;
  }

}
